import { idpService } from 'services/api/identity-provider.service';
import { IMatrixMemberDirectoryEntry } from './types';

export const fetchMatrixMemberDirectory = async (): Promise<IMatrixMemberDirectoryEntry[]> => {
    const members = await idpService.showMembers();
    return members.map((member) => ({
        uid: member.userId,
        email: member.email,
        name: member.name,
        profilePic: member.profile_pic,
        isRegisteredInMatrix: member.is_registered_in_matrix
    }));
};
